import { render, staticRenderFns } from "./TemplateVorschauPopup.vue?vue&type=template&id=4e2db7f7&scoped=true&"
import script from "./TemplateVorschauPopup.vue?vue&type=script&lang=js&"
export * from "./TemplateVorschauPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2db7f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
